import React, { useState } from 'react'
import { ReactSVG } from 'react-svg';


import UserIcon from '../../images/Account.svg'
import CartIcon from '../../images/Cart.svg'
import HeartIcon from '../../images/Heart.svg'
import EyeIcon from '../../images/Eye.svg'
import CloseIcon from '../../images/Close.svg'
import TrashIcon from '../../images/Trash.svg'
import HoodieIcon from '../../images/Hoodie.svg'
import TshirtIcon from '../../images/Tshirt.svg'
import LstIcon from '../../images/Lst.svg'
import SweatShirtIcon from '../../images/Sweatshirt.svg'
import VestIcon from '../../images/Vest.svg'

const IconButton = ({
  icon = 'user',
  // Colors
  iconColor = 'black',
  backgroundColor = 'white',
  borderColor = '',
  hoverBackgroundColor,
  hoverBorderColor,
  hoverTextColor,
  toggleActive,
  activeBackgroundColor,
  activeBorderColor,
  activeTextColor,
  // Sizes
  size = 'md',
  // Hover text
  hoverText,
  // Optional className for additional styling
  className = '',
  onClick
}) => {

  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // Size mappings
  const sizes = {
    sm: {
      wrapper: 'h-8 w-8',
      icon: 16,
      fontSize: 'text-xs'
    },
    md: {
      wrapper: 'h-11 w-11',
      icon: 24,
      fontSize: 'text-sm'
    },
    lg: {
      wrapper: 'h-10 w-10',
      icon: 40,
      fontSize: 'text-base'
    }
  };

  // Icon mappings
  const icons = {
    user: UserIcon,
    cart: CartIcon,
    heart: HeartIcon,
    eye: EyeIcon,
    close: CloseIcon,
    trash: TrashIcon,
    hoodie: HoodieIcon,
    tshirt: TshirtIcon,
    lst: LstIcon,
    sweatshirt: SweatShirtIcon,
    vest: VestIcon,
  };

  const IconComponent = icons[icon];

   // Dynamic styles based on hover and active state
   const wrapperStyles = {
    backgroundColor: isActive ? activeBackgroundColor : (isHovered && hoverBackgroundColor ? hoverBackgroundColor : backgroundColor),
    color: isActive ? activeTextColor : (isHovered && hoverTextColor ? hoverTextColor : iconColor),
    border: borderColor && (`1px solid ${isActive ? activeBorderColor : (isHovered && hoverBorderColor ? hoverBorderColor : borderColor)}`),
    transition: 'all 0.2s ease-in-out'
  };
  
  const handleClick = (e) => {
    if(toggleActive){
      setIsActive( prev => !prev);
    }
    if(onClick) {
      onClick(e)
    }
  }

  return (
    <div className={`
       relative
        rounded-full
        flex
        items-center
        justify-center
        cursor-pointer
        icon
        ${sizes[size].wrapper}
        ${className}
      `}
      style={wrapperStyles}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
       {isHovered && hoverText ? (
        <span 
          className={`
            font-medium
            text-sm
            transition-opacity
            duration-200
            uppercase
          `}
          style={{ 
            color: (isActive && activeTextColor) || (hoverTextColor || iconColor)
          }}
        >
          {hoverText}
        </span>
      ) : (
        <ReactSVG
          src={IconComponent}
          beforeInjection={(svg) => {
            svg.setAttribute('width', `${sizes[size].icon}px`);
            svg.setAttribute('height', `${sizes[size].icon}px`);
            // Set the color of the SVG
            // svg.setAttribute('fill', iconColor);
            // Additional SVG attributes if needed
            svg.setAttribute('class', 'transition-opacity duration-200');
          }}
          wrapper="span"
          className="flex items-center justify-center"
        />
      )}
    </div>
  )
}

export default IconButton